export const formatProjectData = (data) => {
    return {
        ...data
    }
}